import React from "react";
import Home from "../frontends/home/home";
import Projects from "../frontends/projects/projects";
import Experience from "../frontends/experience/experience";
import Contact from "../frontends/contact/contact";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/projects", element: <Projects /> },
  { path: "/experience", element: <Experience /> },
  { path: "/contact", element: <Contact /> },
];

export default routes;
